import { isApiRequestError } from "./apiRequestError";

const NETWORK_ERROR_PATTERN =
  /couldn't reach tessera|could not reach the api|failed to fetch|networkerror|load failed|network request failed/i;

/** HTTP statuses that usually mean the platform is temporarily unavailable. */
const SERVER_UNAVAILABLE_STATUSES = new Set([502, 503, 504, 520, 521, 522, 524]);

export function isServerConnectionError(err: unknown): boolean {
  if (err instanceof TypeError) {
    return true;
  }

  if (isApiRequestError(err)) {
    if (SERVER_UNAVAILABLE_STATUSES.has(err.status)) {
      return true;
    }
    if (err.status >= 500) {
      return true;
    }
  }

  const message =
    typeof err === "string" ? err : err instanceof Error ? err.message : "";
  if (
    message &&
    (NETWORK_ERROR_PATTERN.test(message) ||
      /failed to fetch billing status:\s*(5\d{2}|502|503|504)/i.test(message))
  ) {
    return true;
  }

  return false;
}
